import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Empregador, JornadaPonto } from '../../api.service';

@Component({
  selector: 'app-painel-dados-jornada',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './painel-dados-jornada.component.html'
})
export class PainelDadosJornadaComponent {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input({ required: true }) jornada!: JornadaPonto;
  @Input() jornadas: JornadaPonto[] = [];

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() jornadaChange = new EventEmitter<JornadaPonto>();
  @Output() jornadaSelecionada = new EventEmitter<string>();

  emitirJornada() {
    this.jornadaChange.emit(this.jornada);
  }
}
